import { Route, Routes, Navigate } from 'react-router-dom';
import React from 'react';
import RequireAuth from './components/RequireAuth';
import IsAuthorized from './components/IsAuthorized';
import SyncMoneyListsProteys from './pages/SyncMoneyListsProteys';
import SearchUnpaid from './pages/SearchUnpaid';
import Dashboard from './pages/Dashboard';
import DebtCertificatesToAADE from './pages/DebtCertificatesToAADE';
import MoneyCatalog from './pages/MoneyCatalog';
import MoneyCatalogDetails from './pages/MoneyCatalogDetails';
import Login from './pages/Login';
import AadeSigners from './pages/AadeSigners';
import SearchVerificationDebts from './pages/SearchVerificationDebts';
import Payments from './pages/Payments';
import DebtEntry from './pages/DebtEntry';
import SearchManualDebts from "./pages/SearchManualDebts";

function App() {
  return (
    <>
      <Routes>
        <Route
          exact
          path='/login'
          element={
            <IsAuthorized>
              <Login />
            </IsAuthorized>
          }
        />
        <Route
          path='/dashboard'
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path='/SyncMoneyListsProteys'
          element={
            <RequireAuth>
              <SyncMoneyListsProteys />
            </RequireAuth>
          }
        />
        <Route
          path='/SearchUnpaid'
          element={
            <RequireAuth>
              <SearchUnpaid />
            </RequireAuth>
          }
        />
        <Route
          path='/SearchManualDebts'
          element={
            <RequireAuth>
              <SearchManualDebts />
            </RequireAuth>
          }
        />
        <Route
          path='/DebtEntry'
          element={
            <RequireAuth>
              <DebtEntry />
            </RequireAuth>
          }
        />
        <Route
          path='/deptCertificatesToAADE'
          element={
            <RequireAuth>
              <DebtCertificatesToAADE />
            </RequireAuth>
          }
        />
        <Route
          path='/moneyCatalog'
          element={
            <RequireAuth>
              <MoneyCatalog />
            </RequireAuth>
          }
        />
        <Route
          path='/moneyCatalogDetails/:moneyCatalogId'
          element={
            <RequireAuth>
              <MoneyCatalogDetails />
            </RequireAuth>
          }
        />
        <Route
          path='/tableActiveSigners'
          element={
            <RequireAuth>
              <AadeSigners />
            </RequireAuth>
          }
        />
        <Route
          path='/searchVerificationDebts'
          element={
            <RequireAuth>
              <SearchVerificationDebts />
            </RequireAuth>
          }
        />

        <Route
          path='/payments'
          element={
            <RequireAuth>
              <Payments />
            </RequireAuth>
          }
        />
        <Route path='*' element={<Navigate to='/dashboard' />} />
      </Routes>
    </>
  );
}

export default App;
